export const dateTime = {};

dateTime.date = new Date(); 

dateTime.weekdays = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

dateTime.firstDayOfMonth =  new Date(dateTime.date.getFullYear(), dateTime.date.getMonth(), 1).toLocaleDateString(); 
dateTime.lastDayOfMonth =  new Date(dateTime.date.getFullYear(), dateTime.date.getMonth() + 1, 0).toLocaleDateString();
dateTime.today = dateTime.date.toLocaleDateString();
dateTime.weekday = dateTime.weekdays[dateTime.date.getDay()];

dateTime.currentHour = dateTime.date.getHours();

dateTime.timeOfDays = ["Morning","Afternoon","Evening"];
dateTime.timeOfDayString="";
if (dateTime.currentHour < 12) {
    dateTime.timeOfDayString = dateTime.timeOfDays[0];
} else if (dateTime.currentHour < 18) {
    dateTime.timeOfDayString = dateTime.timeOfDays[1];
} else {
    dateTime.timeOfDayString = dateTime.timeOfDays[2];
}

dateTime.morning = (dateTime.timeOfDayString === "Morning") ? true : false;
dateTime.afternoon = (dateTime.timeOfDayString === "Afternoon") ? true : false;
dateTime.evening = (dateTime.timeOfDayString === "Evening") ? true : false;

dateTime.seasons = ["Spring", "Summer", "Fall", "Winter"];
dateTime.season="";

switch(dateTime.date.getMonth()+1) {
    case 12:
    case 1:
    case 2:
        dateTime.season = dateTime.seasons[3];
    break;
    case 3:
    case 4:
    case 5:
        dateTime.season = dateTime.seasons[0];
    break;
    case 6:
    case 7:
    case 8:
        dateTime.season = dateTime.seasons[1];
    break;
    case 9:
    case 10: 
    case 11:
        dateTime.season = dateTime.seasons[2];
    break;
    default:
        dateTime.season = "";
}

dateTime.spring = (dateTime.season === "Spring") ? true : false;
dateTime.summer = (dateTime.season === "Summer") ? true : false;
dateTime.fall = (dateTime.season === "Fall") ? true : false;
dateTime.winter = (dateTime.season === "Winter") ? true : false;

dateTime.weekend = (dateTime.weekday === "Saturday" || dateTime.weekday === "Sunday") ? true : false;
dateTime.workday = (dateTime.weekday !== "Saturday" && dateTime.weekday !== "Sunday") ? true : false;

// Paste this in Value Trigger to test
// console.log("First day of month: " + afSystem.dateTime.firstDayOfMonth);
// console.log("Last day of month: " + afSystem.dateTime.lastDayOfMonth);
// console.log("Today: " + afSystem.dateTime.today);
// console.log("Current hour: " + afSystem.dateTime.currentHour);
// console.log("Time of day: " + afSystem.dateTime.timeOfDayString);
// console.log("Is morning?:" + afSystem.dateTime.morning);
// console.log("Is afternoon?:" + afSystem.dateTime.afternoon);
// console.log("Is evening?:" + afSystem.dateTime.evening);
// console.log("Current season: " + afSystem.dateTime.season);
// console.log("Is Spring?: " + afSystem.dateTime.spring);
// console.log("Is Summer?: " + afSystem.dateTime.summer);
// console.log("Is Fall?: " + afSystem.dateTime.fall);
// console.log("Is Winter?: " + afSystem.dateTime.winter);
// console.log("Is workday?: " + afSystem.dateTime.workday);
// console.log("Is weekend?: " + afSystem.dateTime.weekend);